let Flags = Object.freeze({
	Type: { view: "v", component: "c", layout: "l" },
	Component: "comp",
	Method: "meth"

});

let applicationManager: any;

declare global {
	namespace AppfactoryStudio {
		var ENVIRONMENT: string; // Must use 'var' to work with globalThis in some cases
		interface AFSExtra { }
	}
}

export class ApplicationContextManager {

	public utils = Utils;

	public extra: any = {}; //AppfactoryStudio.AFSExtra;

	public _props_: any = {};
	public manager: ApplicationManager;
	public factory: ComponentFactory;
	public layout: LayoutManager;
	public componentFactory: ComponentFactory;
	public registered_views: any = [];

	public constructor(config: any) {
		applicationManager = new ApplicationManager(this);
		this.componentFactory = new ComponentFactory(this);
		this.manager = applicationManager;
		this.factory = this.componentFactory;
		this.layout = new LayoutManager();
		this.utils = Utils;
		gl_applicationContextManager = this;
		// this.UsernameValidationCheck = UsernameValidationCheck;

		this._props_ = {
			_ApplicationManager: applicationManager,
			_LayoutManager: new LayoutManager(),
			_ComponentFactory: this.componentFactory,
			_ViewManager: ViewComponent
		};

		applicationManager.init();
	}

	public setAny(param: any, value: any): void {
		this.manager.setAny(param, value);
	}

	public getAny(param: any) {
		return this.manager.getAny(param);
	}

	public getPassThroughParams() {
		return this._props_._passedThruParams;
	}

	public setHash(hash: any) {
		this._props_._handle_hash = hash;
	}

	public getHash() {
		return this._props_._handle_hash;
	}
	public setExtensions(extension: any) {
		this._props_._segmented_plugins = extension;
	}

	public registerView(id: any, view: any) {
		var self = this;
		if (self._props_._registered_views == undefined)
			self._props_._registered_views = {};
		self._props_._registered_views[id] = view;
	}
	public returnRegisteredViews() {
		return this._props_._registered_views;
	}
	public returnView(id: any) {
		return this._props_._registered_views[id];
	}






}


function gl_HandleAll(self: any, opts: any, name: any) {
	// xxxxx
	// type is the name of the function example ButtonComponent
	// in case I need to do something specific for that component.
	// Object.assign(self, new ComponentManager(name, self, opts));
	applicationManager.register(self);// frfrfr
	applicationManager.setComponent(self);
	if (opts != undefined && opts.register != undefined) {
		applicationManager.setAny(opts.register, self);
	}

}

class ApplicationManager {

	public _props_: any;
	public config: any = {};

	constructor(applicationContextManager: any) {

		var rootElement = document.createElement('div');
		rootElement.id = "root-element";
		//rootElement.className = "container";
		this._props_ = {
			_any: {},
			_methods: {},
			_components: [],
			_componentElements: {},
			_routes: {},
			_root_element: rootElement,
			_files: {},
			_basePath: "",
			_file_contents: {},
			_any_id: {},
			_obj_components: null
		};
	}



	/**
	* Starts the application life cycle. Must be called before 
	* running any application code.
	*/
	init(pages: any) {
		var self = this;
		// console.log(self.getRootElement());
		App.call("body").append(self.getRootElement());
		setTimeout(function () {
			ApplicationManager_start_runInterval(self);
		}, 100);
	}


	setRootElement(element: any) {
		this._props_._root_element_component = element;
	}


	// ddddd
	/**
	* Register a method to be called later with in the app
	*/
	register(id: any, method: any, anyId: any) {

		// 888888


		if (!Utils.isNull(method)) {
			this._props_._methods[id] = method;
		} else {
			// console.log(id);
			// if(id.TYPE){
			this._props_._components.push({ id: id.getId(), component: id });
			// }else{
			// 	console.log(id);
			// 	console.error("Element not registered, Must be a component");
			// }
		}
		// hhhhh
		if (anyId != undefined) {
			if (typeof anyId === 'boolean') {
				if (anyId == true) this._props_._any_id[id] = id;
			} else if (typeof anyId === 'string') {
				this._props_._any_id[id] = anyId;
			}
		}
	}

	retrieve(id: any, flag: any) {
		const self = this;
		if (id.charAt(0) == '@') {
			id = id.substr(1);
		}

		if (flag == Flags.Component) {
			return _g();
		} else if (Flags.Method) {
			return this._props_._methods[id];
		} else {
			return _g()
		}
		function _g() {
			var r = null;
			for (var i = 0; i < self._props_._components.length; i++) {
				var t = self._props_._components[i];
				if (t.id == id.getId()) {
					r = self._props_._components[i];
					break;
				}
			}
			return r;
		}
	}

	/**
	* Get all stored objects, by setAny.
	*/
	getAll() {
		return this._props_._any;
	}
	// 757575
	/**
	* Store an object to be retrieved later anywhere with in the app
	*
	* @param {string} id
	* @param {object} any - Any object that needs to be stored for later
	*/
	setAny(id: any, myany: any) {
		this._props_._any[id] = myany;
	}

	setupComponents(id: any, myany: any) {
		this.setAny(id, myany);
		var comps: any = {};
		class hello {
			constructor(myany: any) {
				for (let obj in myany) {
					if (typeof myany[obj] === 'function') {
						// 44441
						comps[obj] = myany[obj](gl_applicationContextManager);
					}
				}
			}

		}

		this.setAny('components', comps);
		return new hello(myany);
	}

	/**
	* Get object set by setAny 
	*
	* @param {string} id - Identifier of object stored
	* @return {object} - returns the object stored
	*/
	getAny(id: any) {
		var any = this._props_._any[id];
		if (Utils.isNull(any)) {
			console.error("No object found for: " + id);
		}
		return any;
	}

	/**
	* Get registered method, set by register()
	*
	*/
	get(id: any, params: any) {
		var method = this._props_._methods[id];
		if (Utils.isNull(method)) {
			console.error("Method: " + id + " does not exist");
		}
		// var paramValues = {
		// 	"params": params,
		// 	"app": gl_applicationContextManager
		// };

		// 44441
		gl_applicationContextManager._props_._passedThruParams = params;
		var component = method(gl_applicationContextManager);
		if (Utils.isNull(component)) {
			console.error("Component: " + id + " is null");
		}

		var anyid = this._props_._any_id[id];
		if (anyid != undefined) {
			this.setAny(anyid, component);
		}
		return component;
	}

	getComponents() {
		return this._props_._components;
	}

	// 5555
	getMethod(id: any, params: any) {
		var method = this._props_._methods[id];
		if (Utils.isNull(method)) {
			console.error("Appfactory method " + id + " does not exist");
		}
		return method;
	}

	run(id: any, params: any) {
		var method = this._props_._methods[id];
		if (Utils.isNull(method)) {
			console.error("Method: " + id + " does not exist");
		}
		var component = method(params);
		if (Utils.isNull(component)) {
			console.error("Component: " + id + " is null");
		}
		return component;
	}

	getComponent(id: any) {
		var components = this._props_._components;
		var component = null;
		for (var i = 0; i < components.length; i++) {
			if (components[i].id == id) {
				component = components[i];
				break;
			}
		}
		if (component == null) {
			console.error("Component: " + id + " not found");
		}
		return component;
	}

	setComponent(tag: any) { // frfrfr
		this._props_._componentElements[tag];
	}

	getLoadedFileContents(alias: any) {
		return this._props_._file_contents[alias];
	}

	templateParser(htmlString: any, replacements: any, opts: any) {
		return ApplicationManager_templateParser(htmlString, replacements, opts, this);
	}

	setFileContents(alias: any, content: any) {
		this._props_._file_contents[alias] = content;
	}
	getFileContents() {
		this._props_._file_contents;
	}

	getRootElement() {
		return this._props_._root_element;
	}


}

class ComponentManager {
	public _props_: any;

	public constructor(name: any, context: any) {
		// _.extend(this, Backbone.Events);
		// console.log(context);
		if (context == undefined || context == null) {
			context = { name: "", TYPE: "" };
		}
		context.name = name;
		context.TYPE = Flags.Type.component;
		let self = this;
		self._props_ = {
			_opts: {},
			_id: "c" + Utils.randomGenerator(16, false),
			_componentName: Flags.Type.component,
			_extensionObject: [],
			_events: [],
			_body: null,

			_isEventsActive: false,
			_uniqueId: "id_" + Utils.randomGenerator(12, false),
			_object_config: null,
			_routes: null,
			_elements: {
				_fragment: document.createDocumentFragment()
			},
			_dom_events: {
				_addToDOMEvent: [],
				_addToDOMEventOnce: null,
				_addToDOMCount: 0,
				_removeFromDOMEvent: [],
				_removeFromDOMEventOnce: null,
				_removeFromDOMCount: 0,
			}
		};
	}


	/**
	* onAttachOnceListener
	*/
	onAttachOnceListener(callback: any) {
		this._props_._dom_events._addToDOMEventOnce = callback;
	};

	/**
	* onDetachOnceListener
	*/
	onDetachOnceListener(callback: any) {
		this._props_._dom_events._removeFromDOMEventOnce = callback;
	};

	/**
	* onAttachListener
	*/
	onAttachListener(listener: any) {

		// console.log(this);
		let len = this._props_._dom_events._addToDOMEvent.length;
		this._props_._dom_events._addToDOMEvent[len] = listener;
	}

	/**
	* onDetachListener
	*/
	onDetachListener(callback: any) {
		var len = this._props_._dom_events._removeFromDOMEvent.length;
		this._props_._dom_events._removeFromDOMEvent[len] = callback;
	}


	/**
	* setParent
	*/
	setParent(parent: any) {
		this._props_._parent = parent;
	}


	/**
	* getParent
	*/
	getParent() {
		return this._props_._parent;
	}

	/**
	* SetId
	*/
	setId(id: any) {
		this._props_._id = id;
	}


	getId() {
		return this._props_._id;
	}

	isAttached() {
		return this._props_._is_attached;
	}


	/**
	* initializeListeners xxxxx
	*/
	initializeListeners() {
		AppComponent_initializeListeners(this);
	};
	deInitializeListener() {
		AppComponent_deInitializeListener(this);
	};

	/**
	* getHtml
	*/
	// getHtml() {
	// 	return document.createElement('div'); //return AppComponent_getHtml(this,route);
	// };

	// append(selector: any){
	// 	return App.call(selector).append(this.getHtml());
	// }

}

class ComponentFactory {
	constructor(obj: any) {

	}

	stub(opts: any) { }

	container(obj: any) {
		return new ContainerComponent(obj);
	}

	view(opts: any = {}) {
		return new ViewComponent(opts);
	}

	sections() {

	}

	button(opts: any) {
		//return new ButtonComponent(opts);
	}

	brick() {
		//return Brick;//new BrickComponent(obj);
	}

	navigation(obj: any) {
		//return new NavigationComponent(obj);
	}

	navbar(opts: any) {
		//return new NavbarComponent(opts);
	}


	nav(opts: any) {
		//return new NavComponent(opts);
	}

	/**
	* Returns a FormComponent
	*/
	form(obj: any) {
		//return new FormComponent(obj);
	}

	formParser(obj: any) {
		//return new FormParser(obj);
	}

	fileUploader(obj: any) {
		//return new FileUploaderComponent(obj);
	}

	list(opts: any) {
		// return new ListComponent(opts);
	}

	dialog(opts: any) {
		//a dialog is created automatically by the system I should not do this
		// return new ModalComponent(opts);
	}

	table(opts: any) {
		//return new TableComponent(opts);
	}

	mobileDialog(obj: any) {
		//return ModalDialogComponent_mobile(obj,this);
	}


	img(opts: any) {
		//return new ImageComponent(opts);
	}


	audio(opts: any) {
		//return new AudioComponent(opts);
	}


	carousel(opts: any) {
		//return new CarouselComponent(opts);
	}

	/**
	* Creates an icon
	*
	* @param {object} - options
	*/
	icon(opts: any) {
		//return new IconComponent(opts);
	}


	showLoading(show: any) {
		// let self = this;

		// let container = `
		// <div id="loading-container" style="" class="loading-container" style="display: block;">
		// 	<div id="myloader" class="loading"></div>
		// 	<div id="loading-text">Loading</div>
		// </div>   
		// `;

		// if(document.getElementById('loading-container')==undefined){
		// 	let node = Utils.convertStringToHTMLNode(container);
		// 	document.body.appendChild(node);
		// }

		// if(show){
		// 	document.getElementById("loading-container").style.display = "block";
		// }else{
		// 	document.getElementById("loading-container").style.display = "none";
		// }

	}




}

class ContainerComponent extends ComponentManager {

	public listenerDelay: number = 1;
	// public _props_: any = {};
	public getHtml: any;
	public TYPE: any = "";
	constructor(opts: any = null) {
		super("ContainerComponent", opts);
		let self = this;
		let isempty = false;
		if (opts == undefined) {
			opts = {};
			isempty = true;
		}
		gl_HandleAll(self, opts, 'ContainerComponent');
		// if(opts.body==undefined && opts.TYPE!=undefined){
		// 	opts.body = opts;
		// }else if(typeof opts === 'string'){
		// 	let tmp = opts;
		// 	opts = {};
		// 	opts.body = Utils.convertStringToHTMLNode(tmp);
		// }

		self._props_._opts = opts;
		if (self._props_._opts.listenerDelay == undefined) { self._props_._opts.listenerDelay = 50; }
		self._props_._fragment = document.createDocumentFragment();
		self._props_._container = document.createElement('div');
		self._props_._container.id = self.getId();
		self._props_._container.setAttribute('data-afscomp', self.getId());
		self._props_._fragment.appendChild(self._props_._container);
		// if(isempty==false){
		// nnnnn
		let body = buildBody(opts);
		if (body != undefined) {
			self._props_._fragment.getElementById(self.getId()).appendChild(body);
		}


		// console.log(opts)
		// console.log(typeof body)

		// if(typeof body === 'object'){
		// 	if(body.TYPE!=undefined){
		// 		body = body.getHtml(true);
		// 	}
		// 	self._props_._fragment.getElementById(self.getId()).innerHTML = Utils.convertFragmentToHTMLText(body);
		// }else if(typeof body === 'string'){
		// 	self._props_._fragment.getElementById(self.getId()).appendChild(body);
		// }else{
		// 	console.warn("no body ", body);
		// }
		// }

		this.getHtml = function (isNode: any = null) {
			let node = this._props_._fragment.cloneNode(true);
			if (isNode) {
				return node;
			}
			return Utils.convertFragmentToHTMLText(node);
		}

	}


	/**
	 * 
	 * @param {boolean} inner If set to true only the element the user specified
	 * is returned not with its container. The default is false so the container 
	 * and user specified element is returned. 
	 * @returns HTMLElement
	 */



	getContainerId() {
		return this._props_._container.id;
	}
	addListener(listener: any) {
		var self = this;
		var obj = {
			listener: listener
		};

		_Utils.registerListenerCallback(obj, this);
		if (document.getElementById(self.getContainerId())) {

		}
	}
	addElement(element: any, empty: any) {
		let self = this;
		let body = buildBody(element);
		if (empty == undefined || empty == true) {
			self._deleteChild(self._props_._fragment.getElementById(self.getId()));
		}
		self._props_._fragment.getElementById(self.getId()).innerHTML = body;
	}

	addComponent(opts: any, empty: any, listenerDelay: any) {
		let self = this;
		if (listenerDelay != undefined) {
			self.listenerDelay = listenerDelay;
		}
		self._props_._opts = self._setup_options(opts);
		if (empty == undefined || empty == true) {
			self._deleteChild(self._props_._fragment.getElementById(self.getId()));
		}
		let body = buildBody(opts);

		if (body != undefined && body != null) {
			if (typeof body === 'string') { // nnnnn
				body = Utils.convertStringToHTMLNode(body);
			}
			self._props_._fragment.getElementById(self.getId()).appendChild(body);
		}

		if (document.getElementById(self.getId())) {
			self._addToDOM();
		}
		self.onAttachListener(function () {
			self._addToDOM();
		});
	}

	_setup_options(opts: any) {
		let self = this;
		if (opts.body == undefined && opts.TYPE != undefined) {
			opts.body = opts.getHtml(true);
		} else if (typeof opts === 'string') {
			let tmp = opts;
			opts = { body: Utils.convertStringToHTMLNode(tmp) };
		} else if (opts.body == undefined) {
			let tmp = opts;
			opts = { body: tmp };
		}
		return opts;
	}
	_deleteChild(e: any) {
		let child = e.lastElementChild;
		while (child) {
			e.removeChild(child);
			child = e.lastElementChild;
		}
	}
	_addToDOM() {
		let self = this;
		let isEmpty = true;
		let id = self.getId();
		if (isEmpty == true) {
			$("#" + id).empty();
		}
		$("#" + id).append(self.getHtml());
		setTimeout(function () {
			if (self._props_._opts.listener != undefined && typeof self._props_._opts.listener === 'function') {
				self._props_._opts.listener();
			}
		}, self.listenerDelay);
	}

}



export interface IViewComponentOptions {
	/**
	 * The id of this view to be called later in the view.render() method
	 */
	id: string,

	/**
	 * The URL route parameter to trigger this view (e.g. "applications" for ?applications=show)
	 */
	route?: string,

	/**
	 * Router settings for this view component.
	 */
	router?: ViewSubViewRouterOptions,

	/**
	 * Is this view the initial view, will be shown first default is false
	 */
	init?: boolean,


	/**
	 * Optional render options passed to render() when the router activates this view.
	 * Use this to render into a target container instead of replacing the view root.
	 */
	renderOptions?: any;

	/**
	 * Data that can be added and passed to the view and accessed throough params._data
	 */
	data?: any,

	/**
	 * Takes a function that returns an HTML string or an html string.
	 */
	// body(opts: any): string | string,

	body: ((params: any, app: ApplicationContextManager) => string) | string;


	/**
	 * Event called when this view is attached to the DOM
	 * @param params Data that passed from the view.render method using params.args and params.data and params.html and params.global
	 * @param app The application context manager 
	 */
	listener?(params: any, app: ApplicationContextManager): void,


	/**
	 * Event called when this view is about to be removed from the DOM
	 * @param params Data that passed from the view.render method using params.args and params.data and params.html and params.global
	 * @param app The application context manager 
	 */
	onExit?(params: any, app: ApplicationContextManager): void,
}

export interface ViewSubViewRouterOptions {
	useHash?: boolean;
}

type ViewRouteHandler = (params?: any) => void;

class ViewSubViewRouter {
	private routes: Record<string, ViewRouteHandler> = {};
	private currentPath: string = '/';
	private useHash: boolean;
	private ignoreNext: boolean = false;
	private fallback: ViewRouteHandler | null = null;
	private debug: boolean;
	private lastUpdatedHash: string | null = null;

	constructor(options?: ViewSubViewRouterOptions) {
		this.useHash = options?.useHash ?? true;
		this.debug = this.isDebug();
		if (typeof window === 'undefined') return;

		if (this.useHash) {
			window.addEventListener('hashchange', () => {
				this.handleRoute(this.getCurrentPath());
			});
		} else {
			window.addEventListener('popstate', () => {
				this.handleRoute(this.getCurrentPath());
			});
		}
	}

	addRoute(path: string, handler: ViewRouteHandler): void {
		this.routes[this.routeKey(path)] = handler;
	}

	setFallback(handler: ViewRouteHandler): void {
		this.fallback = handler;
	}

	start(): boolean {
		return this.handleRoute(this.getCurrentPath());
	}

	handleRoute(fullPath: string, params?: any): boolean {
		if (this.debug) {
			console.debug('[ViewSubViewRouter] handleRoute', { fullPath });
		}
		if (this.ignoreNext && this.useHash && this.lastUpdatedHash === fullPath) {
			this.ignoreNext = false;
			return false;
		}
		this.ignoreNext = false;

		const [path, queryString] = fullPath.split('?');
		this.currentPath = path || '/';
		const handler = this.routes[this.routeKey(this.currentPath)];

		if (queryString) {
			const urlParams = new URLSearchParams(queryString);
			params = { ...params };
			urlParams.forEach((value, key) => {
				params[key] = value;
			});
		}

		if (handler) {
			handler(params);
			return true;
		}

		if (this.fallback) {
			this.fallback(params);
			return true;
		}

		return false;
	}

	updateUrl(path: string, replace: boolean = false): void {
		if (typeof window === 'undefined') return;
		const normalized = this.normalize(path);
		// Only suppress the immediate hashchange we trigger ourselves.
		// For history mode (pushState/replaceState), no event fires, so keep handling popstate.
		this.ignoreNext = this.useHash;
		this.lastUpdatedHash = this.useHash ? normalized : null;

		if (this.useHash) {
			if (replace) {
				const newUrl = window.location.pathname + window.location.search + '#' + normalized;
				window.history.replaceState({ path: newUrl }, '', newUrl);
			} else {
				window.location.hash = normalized;
			}
			return;
		}

		if (replace) {
			window.history.replaceState({ path: normalized }, '', normalized);
		} else {
			window.history.pushState({ path: normalized }, '', normalized);
		}
	}

	private getCurrentPath(): string {
		if (typeof window === 'undefined') return '/';
		if (this.useHash) {
			return window.location.hash.slice(1) || '/';
		}
		return window.location.pathname + window.location.search;
	}

	private normalize(path: string): string {
		if (!path) return '/';
		const [pathAndQuery = '', hashFragment] = path.split('#');
		const [pathname = '', queryString] = pathAndQuery.split('?');
		const safePathname = pathname || '/';
		const normalizedPath = safePathname.startsWith('/') ? safePathname : `/${safePathname}`;
		const queryPart = queryString ? `?${queryString}` : '';
		const hashPart = hashFragment ? `#${hashFragment}` : '';
		return `${normalizedPath}${queryPart}${hashPart}`;
	}

	private routeKey(path: string): string {
		const normalized = this.normalize(path);
		const [pathAndQuery = ''] = normalized.split('?');
		const [pathname = ''] = pathAndQuery.split('#');
		return pathname || '/';
	}

	private isDebug(): boolean {
		if (typeof window === 'undefined') return false;
		const env = (window as any).AppfactoryStudio?.ENVIRONMENT;
		return env === 'development';
	}
}

/**
 * ViewSubViewRouter wiring for ViewComponent.
 *
 * How it works:
 * - Define `route` on each subview to map a URL path to that view.
 * - Optionally pass `router: { useHash: true | false }` on any subview. This
 *   initializes the router for the view component (hash routing by default).
 * - Use `renderOptions` to render a routed subview into a container instead of
 *   replacing the view root (e.g. `{ container: 'dashboard-content' }`).
 * - Call `view.startRouter()` after all `newSubView` registrations so the
 *   router can render the correct view based on the current URL.
 * - When a view is rendered, its route updates the URL automatically.
 * - Unknown routes fall back to the first `init: true` view (or the first view).
 *
 * Example usage:
 * const view = app.factory.view();
 * view.newSubView({ id: 'dashboard', route: '/', router: { useHash: true }, body: dashboardHtml });
 * view.newSubView({ id: 'forms', route: '/forms', body: formsHtml });
 * view.startRouter();
 */
export class ViewComponent extends ComponentManager {

	public _opts: any;



	public constructor(opts: any, data: any = null) {
		if (typeof opts == 'string') { opts = { name: opts }; }
		super("ViewComponent", opts);
		gl_HandleAll(this, opts, 'ViewComponent');
		let self = this;
		self._opts = (opts == undefined) ? {} : opts;
		self._props_._container = new ContainerComponent();
		self._props_._views = [];
		self._props_._current_view = null;
		self._props_._render_opts = { params: null, opts: null };
		self._props_._router = null;
		self._props_._router_started = false;
		self._props_._data = data;
		self._props_._html = null;

		gl_applicationContextManager.registered_views.push(self._props_._container.getId());
		// $("#view_events_element").on("view_enter_afs", function (e: any) {

		// });


		// self.getHtml = function (inner: any) {

		// 	// let node = Utils_convertStringToHTMLNode(self._props_._container.getHtml(inner));
		// 	// return node;
		// 	return self._props_._container.getHtml(inner);
		// }

		// console.log(this);
	}

	getHtml(inner: any = null, data: any = null) {
		const self = this;
		if (data != null) {
			self._props_._html = data;
		}
		return this._props_._container.getHtml(inner);
	}


	/**
	 * Create a single view
	 * @param opts 
	 * @param body 
	 * @param init 
	 * @returns 
	 */
	newSubView(opts: IViewComponentOptions, body: any = null, init: any = false) {
		let self = this;
		opts = self._convert_to_afsopts(opts, body, init);
		self._print_newSubView_errors(opts);
		self._props_._views.push(opts);

		if (opts.route) {
			self._ensure_router(opts.router);
			self._register_route(opts);
		}

		if (opts.init != undefined && opts.init == true) {
			let newOpts: any = opts;
			newOpts.params = {};
			newOpts.params.html = self._props_._html;
			newOpts.params.data = opts.data;
			newOpts.params.global = self._props_._data;
			newOpts.params.args = {};
			self._build_view(newOpts, self);
			self._props_._current_view = opts.id;
		}

		return this;
	}

	private _ensure_router(routerOptions?: ViewSubViewRouterOptions): void {
		if (this._props_._router) return;
		this._props_._router = new ViewSubViewRouter(routerOptions);
		this._props_._router.setFallback(() => {
			const fallbackView = this._getFallbackView();
			if (fallbackView) {
				this.render(fallbackView.id);
			}
		});
	}

	private _getFallbackView(): any {
		if (!this._props_._views || this._props_._views.length === 0) return null;
		const initView = this._props_._views.find((view: any) => view.init === true);
		return initView || this._props_._views[0];
	}

	private _register_route(viewOpts: any): void {
		if (!this._props_._router || !viewOpts.route) return;
		const route = this._normalize_route(viewOpts.route);
		this._props_._router.addRoute(route, (params: any) => {
			this.render(viewOpts.id, params, viewOpts.renderOptions);
		});
	}

	private _normalize_route(route: string): string {
		if (!route) return '/';
		return route.startsWith('/') ? route : `/${route}`;
	}

	public startRouter(): boolean {
		if (!this._props_._router || this._props_._router_started) return false;
		this._props_._router_started = true;
		const routed = this._props_._router.start();
		if (!routed) {
			return this._match_query_route();
		}
		return routed;
	}

	private _match_query_route(): boolean {
		if (typeof window === 'undefined') return false;
		const urlParams = new URLSearchParams(window.location.search);
		for (let i = 0; i < this._props_._views.length; i++) {
			const view = this._props_._views[i];
			if (view?.route) {
				const key = view.route.replace(/^\//, '');
				if (urlParams.has(key)) {
					this.render(view.id);
					return true;
				}
			}
			if (view?.id && urlParams.has(view.id)) {
				this.render(view.id);
				return true;
			}
		}
		return false;
	}

	_check_url_for_view(id: string) {
		if (typeof window === 'undefined') return false;
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.has(id);
	}
	render(id: string, params: any = {}, renderOpts: any = {}) {
		let self = this;
		renderOpts = (renderOpts) ? renderOpts : {};
		let viewOpts = null;
		for (let i = 0; i < self._props_._views.length; i++) {
			if (id == self._props_._views[i].id) { viewOpts = self._props_._views[i]; break; }
		}
		if (viewOpts == null) { console.warn("No subview: " + id); return; }

		let cont = document.getElementById(self.getId());
		if (cont == null && renderOpts.container != undefined) {
			self._props_._current_view = "";
		}

		if (self._props_._current_view != id) {
			if (document.getElementById(self._props_._container.getId())) {
				let _v = self.__getView(self._props_._current_view);
				// console.log(_v)
				if (_v != null && _v.onExit != undefined && typeof _v.onExit === 'function') {
					_v.onExit(viewOpts, gl_applicationContextManager);
				}
			}
			self._props_._current_view = id;
			self._props_._render_opts = { params: params, opts: renderOpts };
			viewOpts.params = params;
			self._build_view(viewOpts, renderOpts);

			// Update URL
			if (viewOpts.route) {
				self._update_url(viewOpts);
			}
		}
	}

	_update_url(viewOpts: any) {
		if (typeof window === 'undefined') return;
		if (this._props_._router && viewOpts.route) {
			this._props_._router.updateUrl(this._normalize_route(viewOpts.route));
			return;
		}
		const urlParams = new URLSearchParams(window.location.search);
		const route = viewOpts.route;

		// Remove match for other views in this component
		if (this._props_._views) {
			this._props_._views.forEach((v: any) => {
				if (v.id !== viewOpts.id && v.route && urlParams.has(v.route)) {
					urlParams.delete(v.route);
				}
			});
		}

		// Set current view param
		urlParams.set(route, 'show');

		// Update URL without reloading
		const newUrl = window.location.pathname + '?' + urlParams.toString() + window.location.hash;
		window.history.pushState({ path: newUrl, viewId: viewOpts.id }, '', newUrl);
	}

	_build_view(viewOpts: any, renderOpts: any = undefined) {
		let self = this;
		let body = buildBody(viewOpts, self);
		if (renderOpts != undefined && renderOpts.container != undefined) {
			let containerId = renderOpts.container;

			const myInput = document.getElementById(containerId) as HTMLElement | null;
			if (myInput) {
				if (renderOpts.clear !== false) {
					myInput.innerHTML = '';
				}
				
				myInput.appendChild(body.cloneNode(true));
			}

			// document.getElementById(containerId).appendChild(body.cloneNode(true));

			if (viewOpts.listener != undefined && typeof viewOpts.listener === 'function') {
				viewOpts.listener(viewOpts.params, gl_applicationContextManager);
			}
		} else {
			if (body == undefined || body == null) {
				console.warn(viewOpts);
				body = "<div></div>";
			}
			if (body.TYPE) { body = body.getHtml(); }
			self._props_._container.addComponent({
				// TODO: addComponent only accepts a string to build the body
				body: (typeof body === 'object') ? Utils.convertFragmentToHTMLText(body) : body,
				listener: function () {
					if (viewOpts.listener != undefined && typeof viewOpts.listener === 'function') {
						viewOpts.listener(viewOpts.params, gl_applicationContextManager);
					}
				}
			}, true);
		}
	}
	__getView(id: any) {
		const self = this;
		let viewOpts = null;
		for (let i = 0; i < self._props_._views.length; i++) {
			if (id == self._props_._views[i].id) {
				viewOpts = self._props_._views[i];
				break;
			}
		}
		return viewOpts;
	}

	_print_newSubView_errors(opts: any) {
		let self = this;
		// no id error notice 
		if (opts.id == undefined) {
			opts.id = 'p' + Utils.randomGenerator(12);
			console.warn("View Component does not contain an id");
		}

		// repeat view error notice
		for (var i = 0; i < self._props_._views.length; i++) {
			if (opts.id == self._props_._views[i].id) {
				console.error("Theres already a View Component with the id: " + opts.id);
				break;
			}
		}

	}


	getContainerId() {
		// 50505 - this is returning an html object
		return this._props_._containers.getContainerId();
	}

	goTo(index: any, opts: any) {
		// ViewManager_goTo(index,opts,this);
	}


	back(opts: any) {
		// ViewManager_back(opts,this);
	}

	next(opts: any) {
		// ViewManager_next(opts,this);
	}

	/**
	*
	*/
	getRouteFromId(id: any) {
		// return MultiView_getRouteFromId(id,this);
	}

	getCurrentViewInRoute() {
		// return MultiView_getCurrentViewInRoute(this);
	}


	getCurrentView() {
		return this._props_._current_view;
	}

	getView(id: any) {
		return this.MultiView_getView(id, this);
	}


	_convert_to_afsopts(opts: any, body: any, init: any) {
		let self = this;
		if (typeof opts === 'string' && body != undefined) {
			let _id = opts;
			opts = {
				init: (init != undefined && typeof init === 'boolean') ? init : false,
				id: _id,
				body: body
			};
		} else if (typeof opts === 'boolean' && typeof body === 'string' && init != undefined) {
			opts = {
				init: init,
				id: body,
				body: init
			};
		}
		return opts;
	}

	isRoutable() {
		return this._props_._is_routable;
	}






	ViewManager_render2(id: any, params: any, opts: any, self: any) {
		// if(self._props_._options.append!=undefined){
		// 	if(!document.getElementById(self._props_._containers.getContainerId())){
		// 		var doc = document.getElementById(self._props_._options.append);
		// 		if(doc!=null && doc!=undefined){
		// 			$('#'+self._props_._options.append).empty();
		// 			doc.appendChild(self._props_._containers.getHtml());
		// 			console.log('hit 1 ' + id);
		// 			return;
		// 		}
		// 	}
		// }


		var replace = true;
		opts = (opts) ? opts : {};
		var mOpts = null;
		for (var i = 0; i < self._props_._views_objects.length; i++) {
			if (id == self._props_._views_objects[i].id) {
				mOpts = self._props_._views_objects[i];
				break;
			}
		}

		// 50505
		// var id = self._props_._containers.getContainerId();
		// if(document.getElementById(id)){
		// 	$('body').append(self._props_._containers.getHtml());
		//console.log(self._props_._options);
		//console.log(self._props_._containers.getContainerId());
	}
	ViewManager_back(opts: any, self: any) {
		var current = self._props_._current_view;
		var index = -1;
		var canGo = false;
		var next_current = '';
		var length = self._props_._view_order.length;
		for (var i = 0; i < length; i++) {
			if (self._props_._view_order[i] == current) {
				index = (i - 1);
				if (index >= 0) {
					canGo = true;
				}
				break;
			}
		}
		if (canGo) {
			var view = self._props_._view_order[index];
			self.render(view, opts);
		}
	}


	ViewManager_goTo(index: any, opts: any, self: any) {
		if (typeof index === 'string') {
			self.render(index, opts);
		} else if (typeof index === 'number') {
			if ((self._props_._view_order.length - 1) >= index) {
				var view = self._props_._view_order[index];
				self.render(view, opts);
			}
		}
	}
	getNewRoute(id: any, self: any) {
		var hash = window.location.hash;
		var current_route = self.getCurrentViewInRoute();
		var route = "";
		var routeFromId = self.getRouteFromId(id);

		if (current_route != null) {
			route = hash.replace(current_route.trim(), routeFromId.trim());
		} else {
			route = hash + "/" + routeFromId;
		}
		return route;
	}
	MultiView_getCurrentViewInRoute(self: any) {
		var routes = window.location.hash.split("/");
		// console.log(routes);
		var views = self._props_._views_objects;
		var current_route = null;
		var breakMe = false;
		for (var i = 1; i < routes.length; i++) {
			for (var n = 0; n < views.length; n++) {
				if (routes[i] == views[n].route) {
					current_route = views[n].route;
					breakMe = true;
					break;
				}
				if (breakMe) break;
			}
		}
		return current_route;
	}
	MultiView_getRouteFromId(id: any, self: any) {
		var views = self._props_._views_objects;
		var route = "";
		for (var i = 0; i < views.length; i++) {
			if (views[i].id == id) {
				route = views[i].route;
			}
		}
		return route;
	}
	MultiView_getView(id: any, self: any) {
		var views = self._props_._views_objects;
		var view = null;
		for (var i = 0; i < views.length; i++) {
			if (views[i].id == id) {
				view = views[i];
			}
		}
		return view;

	}

}


// 9999
/** @exports LayoutManager
* @classdesc A compoment that handles the layout of components.
* @class
* @constructor
*/
class LayoutManager {

	constructor() { }

	newLayout(obj: any) {
		return new AppLayout(obj);
	}

}


class AppLayout extends ComponentManager {

	public getHtml: any;

	constructor(obj: any) {
		super("AppLayout", obj);
		var self = this;

		// console.log(id);
		gl_HandleAll(this, obj, "AppLayout");

		AppLayout_constructor(obj, this);

		this.getHtml = function () {
			if (self._props_._isBuilt == false) {
				console.error('Layout has not been built.')
			}
			return AppComponent_getHtml_layout_fragment(self);
		};

		this._props_._isBuilt = false;

	}

	/**
	* Adds a bootstrap columne class div element to the layout.
	* @param {Object} columns - lg,md,sm,xs offset
	* @param {Array} arrayOfItems - an array of ViewComponentControllers, ViewCollectionControllers and/or other ViewLayoutControllers
	* @param {Object} elementProperties - Add classes or id to this column
	* @return {object} this
	*/
	col(columns: any, arrayOfItems: any, obj: any) {
		AppLayout_col(columns, arrayOfItems, obj, this);
		return this;
	}

	/**
	* Adds a bootstrap row class div element to the layout.
	* @return {objec} this
	*/
	row(obj: any) {
		AppLayout_row(obj, this);
		return this;
	}

	/**
	* Builds the layout. must be called before layout can be appended to the document.
	*/
	build() {
		AppLayout_build(this);
		return this;
	}


}



function AppComponent_getHtml_layout_fragment(self: any) {
	return self._props_._elements._fragment.cloneNode(true);
}
function AppLayout_constructor(obj: any, self: any) {
	//applicationManager.register(this);
	obj = (Utils.isNull(obj)) ? {} : obj;
	//this.TYPE = GL_TYPES.layout;
	self.ID = "d-" + Utils.randomGenerator(12, false);

	//ALL_COMPONENTS[ALL_COMPONENTS.length] = {id:this.ID,component:this};
	self._html = "";
	self._custHtml = [];
	self._fragment = null;
	self._id = (Utils.isNull(obj.id)) ? "VL-" + Utils.randomGenerator(24, false) : obj.id;

	self._typeHolder = {
		typeComponent: [],
		typeView: [],
		typeLayout: []
	};

	self._columns = [];
	self._rows = [];

	self._build_order = [];



	self._buildNodes = [];

	self._container_row = 0;
	self._container_col = [];

	var className = (Utils.isNull(obj.className)) ? "" : obj.className;
	if (className == "") {
		className = (Utils.isNull(obj.classes)) ? "" : obj.classes;
	}
	var styles = (Utils.isNull(obj.style)) ? "" : obj.style;
	if (styles == "") {
		styles = (Utils.isNull(obj.styles)) ? "" : obj.styles;
	}

	self._props_ = {
		_id: self._id,
		_uniqueId: "id_" + Utils.randomGenerator(12, false),
		_isEventsActive: false,
		_events: [],
		_routes: obj.routes,
		_statemananger_route: obj.routes,
		_layout_container: {},
		_current_row_id: "default",
		columns: [],
		rows: [],
		_parent: null,
		_elements: {
			_fragment: document.createDocumentFragment()
		},
		_extensionObject: [],
		_fragmentParent: null,
		_super_view_id: null,
		_top_row: {
			_id: self._id,
			_classes: className,
			_styles: styles
		},
		_dom_events: {
			_addToDOMEvent: [],
			_addToDOMEventOnce: null,
			_addToDOMCount: 0,
			_removeFromDOMEvent: [],
			_removeFromDOMEventOnce: null,
			_removeFromDOMCount: 0,
		}
	};

	self._props_._layout_container["default"] = {
		type: "row",
		columns: []
	}

	self._reset = 0;

}
function AppLayout_row(obj: any, self: any) {
	var currentRow = Utils.randomGenerator(9, false);
	self._props_._current_row_id = currentRow;
	self._props_._layout_container[currentRow] = {
		type: "row",
		obj: obj,
		columns: []
	};
}

function isBuildBody(body: any) {
	var isbody = false;
	if (Array.isArray(body)) {
		if (body.length == 2) {
			if (body[0].includes("@")) {
				isbody = true;
			}
		}
	} else {
		isbody = true;
	}


	return isbody;

}
function AppLayout_col(columns: any, arrayOfItems: any, obj: any, self: any) {
	if (!Array.isArray(arrayOfItems)) {
		arrayOfItems = [arrayOfItems];
	} else {
		// because buildBody can except an array and if an array is
		// passed in check to see if this array is a body, if so
		// wrap body array in outer array
		if (isBuildBody(arrayOfItems)) {
			arrayOfItems = [arrayOfItems];
		}

	}

	// 3333

	var currentRow = self._props_._current_row_id;
	var len = self._props_._layout_container[currentRow].columns.length;
	self._props_._layout_container[currentRow].columns[len] = [
		columns, arrayOfItems, obj, self
	];
}
// 3333
function AppLayout_build(self: any) {
	// Each time a new row is created an object is added to 
	// the layout_container object. The layout_container
	// has two properties type and columns. When the row
	// method is called the column property is initialed 
	// with an empty array and the type is row. 

	self._props_._isBuilt = true;
	self._props_._elements._fragment = document.createDocumentFragment();
	var layout = self._props_._layout_container;

	var row_count = 0;

	for (let prop in layout) {
		var row = document.createElement("div");
		var topRowClasses = "";
		if (row_count == 1) {
			topRowClasses = self._props_._top_row._classes;
			row.id = self._props_._top_row._id;
			row.style = self._props_._top_row._styles;
		}

		var columns = layout[prop].columns;
		//console.log(layout[prop]);
		var containerColumn = null;

		if (!Utils.isNull(layout[prop].obj)) {
			if (!Utils.isNull(layout[prop].obj.classes)) {
				topRowClasses = layout[prop].obj.classes;
			} else if (!Utils.isNull(layout[prop].obj.className)) {
				topRowClasses = layout[prop].obj.className;
			}
			//topRowClasses = (Utils.isNull(layout[prop].obj.classes)) ? "" : layout[prop].obj.classes;
		}

		row.id = (!Utils.isNull(layout[prop].obj) && !Utils.isNull(layout[prop].obj.id)) ? layout[prop].obj.id : "";
		//topRowClasses = (!Utils.isNull(layout[prop].obj) && !Utils.isNull(layout[prop].obj.id)) ? layout[prop].obj.id : "";
		row.className = "row " + topRowClasses;
		for (var i = 0; i < columns.length; i++) {
			if (Utils.isNull(columns[i][1])) {
				containerColumn = document.createElement("div");
				containerColumn.className = _getLayoutColumnClasses(columns[i][0]);
				row.appendChild(containerColumn);
			} else {
				var column = ViewLayoutController_col(columns[i][0], columns[i][1], columns[i][2], columns[i][3]);
				if (!Utils.isNull(containerColumn)) {
					containerColumn?.appendChild(column);
				} else {
					row.appendChild(column);
				}
			}
		}

		var ap = document.createElement("div");
		ap.id = self.getId();
		row.appendChild(ap);
		self._props_._elements._fragment.appendChild(row);

		if (columns.length == 0) { containerColumn = null; }
		row_count++;
	}
}


function ViewLayoutController_col(columns: any, arrayOfItems: any, obj: any, self: any) {

	obj = (Utils.isNull(obj)) ? {} : obj;
	let viewid = obj.viewid;

	var colClasses = _getLayoutColumnClasses(columns);
	var viewId: any = (viewid == null || viewid == undefined) ? "" : viewid;
	var cl = (obj.classes == null || obj.classes == undefined) ? "" : obj.classes;
	var id = (obj.id == null || obj.id == undefined) ? "" : obj.id;
	var st = (obj.styles == null || obj.styles == undefined) ? "" : obj.styles;

	var _fragment = document.createDocumentFragment();
	var topDiv = document.createElement("div");
	topDiv.className = colClasses + " " + cl;
	topDiv.id = id;
	topDiv.style = st;

	var nodes: any = [];

	var divRow = null;

	// if(typeof arrayOfItems == "string"){
	// 	if(arrayOfItems=="row"){}else{}
	// }else if(typeof arrayOfItems == "object") 
	// }else if(Array.isArray(arrayOfItems)){}

	for (var i = 0; i < arrayOfItems.length; i++) {
		if (typeof arrayOfItems[i] == "string") {
			if (arrayOfItems[i].includes("row")) {
				var rows1 = arrayOfItems[i].split(" ");
				var row_classes = "";
				var row_id = "";
				for (var m = 1; m < rows1.length; m++) {

					if (rows1[m].includes("id=")) {
						var row1_id = rows1[m].split("=")[1];
						row_id = row1_id;
					} else {
						if (row_classes == "") {
							row_classes += rows1[m];
						} else {
							row_classes += " " + rows1[m];
						}
					}
				}
				divRow = document.createElement("div");
				divRow.className = "row " + row_classes;
				if (row_id != "") {
					divRow.id = row_id;
				}
			} else {
				var mycomp = _getComponentFromRout(arrayOfItems[i], self);
				_handleLayoutType(mycomp, divRow, nodes, colClasses, _fragment, id, st, cl, viewId, topDiv, self);
			}
		} else {
			_handleLayoutType(arrayOfItems[i], divRow, nodes, colClasses, _fragment, id, st, cl, viewId, topDiv, self);
		}
	}
	return topDiv;
}
// 5050
function _getComponentFromRout(obj123: any, self: any) {
	var mycomp = null;
	var arrayOfItems = [obj123],
		i = 0;

	// 4444
	// something that may not be needed
	if (arrayOfItems[i].charAt(0) == "#") {
		// //console.log(self);
		// var c = stateManager.getMapRoute(self._props_._routes.route,arrayOfItems[i]);
		// var f = applicationManager.retrieve(c,Flags.Method);
		// if(typeof f === "function"){
		// 	mycomp = f(self._props_._routes);
		// }else{
		// 	console.error(arrayOfItems[i]+" is not a function for rout: "+self._props_._routes.route);
		// }
	} else if (arrayOfItems[i].charAt(0) == "@") {
		//var f = applicationManager.retrieve(arrayOfItems[i],Flags.Method);
		mycomp = buildBody(arrayOfItems[i]);
		// if(typeof f === "function"){
		// 	mycomp = f(self._props_._routes);
		// }else if(f.TYPE){
		// 	mycomp = f;
		// }else{
		// 	// 1212
		// 	mycomp = _create_body({ body: arrayOfItems[i], original: true });
		// 	// hhhhh
		// 	//console.log(mycomp); 
		// 	//console.error(arrayOfItems[i]+" is not a function for rout: "+self._props_._routes.route);
		// }
	}
	return mycomp;
}

// 4444 - change all possible ways of making a body to buildBody() method
function _handleLayoutType(obj123: any, divRow: any, nodes: any, colClasses: any, _fragment: any, id: any, st: any, cl: any, viewId: any, topDiv: any, self: any) {
	var arrayOfItems = [obj123];
	var componentManager: any = new ComponentFactory({});
	var i = 0;
	if (Utils.isNull(obj123)) return;
	if (arrayOfItems[i].TYPE == Flags.Type.component) {
		if (arrayOfItems[i].setParent) {
			arrayOfItems[i].setParent(self);
		}
		self._typeHolder["typeComponent"][self._typeHolder.typeComponent.length] = arrayOfItems[i];

		self._props_._extensionObject[self._props_._extensionObject.length] = arrayOfItems[i];

		var node = buildBody(arrayOfItems[i], self);

		if (divRow != null) {
			divRow.appendChild(node);
			topDiv.appendChild(divRow);
			divRow = null;
		} else {
			topDiv.appendChild(node.cloneNode(true));
		}

	} else
		if (arrayOfItems[i].TYPE == Flags.Type.layout) {
			if (arrayOfItems[i].setParent) {
				arrayOfItems[i].setParent(self);
			}
			self._typeHolder.typeLayout[self._typeHolder.typeLayout.length] = arrayOfItems[i];

			self._props_._extensionObject[self._props_._extensionObject.length] = arrayOfItems[i];

			var node;
			if (typeof arrayOfItems[i].getHtml(self._props_._routes) === "string") {
				node = Utils.convertStringToHTMLNode(arrayOfItems[i].getHtml(self._props_._routes));
			} else if (typeof arrayOfItems[i].getHtml(self._props_._routes) === "object") {
				node = arrayOfItems[i].getHtml(self._props_._routes);
			}

			if (divRow != null) {
				divRow.appendChild(node);
				topDiv.appendChild(divRow);
				divRow = null;
			} else {
				topDiv.appendChild(node);
			}

		} else
			if (arrayOfItems[i].TYPE == Flags.Type.view) {
				if (arrayOfItems[i].setParent) {
					arrayOfItems[i].setParent(self);
				}
				self._typeHolder.typeView[self._typeHolder.typeView.length] = arrayOfItems[i];

				self._props_._extensionObject[self._props_._extensionObject.length] = arrayOfItems[i];

				var _view_ = arrayOfItems[i];
				var options = _view_._props_._options;
				var routeView;
				if (options.routable) {
					routeView = _getViewFromRoute();
				} else {
					routeView = _gethandledView();
				}
				var v = _getComponentType(routeView);
				$(_view_._props_._container).empty();
				_view_._props_._container.appendChild(v.getHtml());
				topDiv.appendChild(_view_._props_._container.cloneNode(true));

				/////////////////////////////////////


				function _getComponentType(obj: any) {
					if (Utils.isNull(obj.body)) {
						var blankComponent = componentManager.container({
							body: "<div></div>"
						});
						return blankComponent;
					}
					var body = obj.body;
					if (typeof body === "string") {
						if (body.charAt(0) === "@") {
							//var view = _getView(body,obj); hhhhh
							var view = buildBody(body, obj);
							if (Utils.isNull(view)) { return blankComponent; }
							return view;
						} else {
							var stringComponent = componentManager.container({
								body: body,
								listener: obj.listener
							});
							return stringComponent;
						}
					} else if (typeof body === "object") {
						if (!Utils.isNull(body.TYPE)) {
							return body;
						} else {
							var stringComponent = componentManager.container({
								body: body,
								listener: obj.listener
							});
							return stringComponent;
						}
					}
					return null;
				}

				function _gethandledView() {
					var rt = _view_._props_._views_objects;
					var view;
					for (var i = 0; i < rt.length; i++) {
						if (!Utils.isNull(rt[i].init) && rt[i].init == true) {
							view = rt[i];
							break;
						}
					}
					if (Utils.isNull(view)) {
						view = componentManager.container({
							body: "<div></div>"
						});
					}
					return view;
				}

				function _getViewFromRoute() {
					// var params = pages.getRoute().params;
					// var rt = _view_._props_._views_objects;

					// var validRoute = false;
					// // get init view as a default 
					// var route_view = null;
					// console.log(rt)
					// for(var i=0; i<rt.length; i++){
					// 	if(!Utils.isNull(rt[i].route)){
					// 		for(var n=0; n<params.length; n++){
					// 			if(params[n] == rt[i].route){
					// 				route_view = rt[i];
					// 				validRoute = true;
					// 				break;
					// 			}
					// 		}
					// 		if(validRoute) break;
					// 	}
					// }
					// if(route_view==null){
					// 	route_view = _gethandledView();
					// }
					// return route_view;
				}

			} else {
				if (arrayOfItems[i].setParent) {
					arrayOfItems[i].setParent(self);
				}
				self._typeHolder["typeComponent"][self._typeHolder.typeComponent.length] = arrayOfItems[i];

				self._props_._extensionObject[self._props_._extensionObject.length] = arrayOfItems[i];

				var node = buildBody(arrayOfItems[i], self);

				if (divRow != null) {
					divRow.appendChild(node);
					topDiv.appendChild(divRow);
					divRow = null;
				} else {

					topDiv.appendChild(node);
				}

			}

}
function _getLayoutColumnClasses(columns: any) {

	// col-lg col-md col-sm col-xs col-offset-lg col-offset-md
	//

	/*


					Extra small devices Small devices 		Medium devices 		Large devices
					Phones (<768px)     Tablets (≥768px)	Desktops (≥992px)	Desktops (≥1200px)
					------------------- ----------------	-----------------	------------------
	.visible-xs-*	Visible				Hidden				Hidden				Hidden
	.visible-sm-*	Hidden				Visible				Hidden				Hidden
	.visible-md-*	Hidden				Hidden				Visible				Hidden
	.visible-lg-*	Hidden				Hidden				Hidden				Visible
	.hidden-xs		Hidden				visible-lg			Visible				Visible
	.hidden-sm		Visible				Hidden				Visible				Visible
	.hidden-md		Visible				Visible				Hidden				Visible
	.hidden-lg		Visible				Visible				Visible				Hidden

	.visible-*-block		display: block;
	.visible-*-inline		display: inline;
	.visible-*-inline-block	display: inline-block;

	*/


	var colClasses = "";

	//console.log(columns);

	for (let col in columns) {


		if (col == "col") {
			if (colClasses == "") {
				colClasses = " col-" + columns[col];
			} else {
				colClasses = colClasses + " col-" + columns[col];
			}
		} else if (col == "xs" || col == "sm" || col == "md" || col == "lg" || col == "xl") {
			if (colClasses == "") {
				colClasses = colClasses + " " + colClasses + "col-" + col + "-" + columns[col] + " ";
			} else {
				colClasses = colClasses + " " + colClasses + "col-" + col + "-" + columns[col] + " ";
			}
		} else if (col.includes("offset")) {
			colClasses = colClasses + " " + _sortClassesOffset(col, columns, colClasses);
		} else if (col.includes("visible")) {
			colClasses = colClasses + " " + _sortClassesVisible(col, columns, colClasses);
		} else if (col.includes("hidden")) {
			colClasses = colClasses + " " + _sortClassesHidden(col, columns, colClasses);
		} else if (col == "d_x_none") {
			colClasses = _sortClassesDisplay(col, columns, colClasses);
		} else if (col == "d_none") {
			colClasses = _sortClassesDisplay(col, columns, colClasses);
		} else if (col == "d_inline") {
			colClasses = _sortClassesDisplay(col, columns, colClasses);
		} else if (col.includes("d_inline_block")) {
			colClasses = _sortClassesDisplay(col, columns, colClasses);
		} else if (col == "d_block") {
			colClasses = _sortClassesDisplay(col, columns, colClasses);
		} else if (col.includes("d_table")) {
			colClasses = _sortClassesDisplay(col, columns, colClasses);
		} else if (col.includes("d_table_cell")) {
			colClasses = _sortClassesDisplay(col, columns, colClasses);
		} else if (col.includes("d_table_row")) {
			colClasses = _sortClassesDisplay(col, columns, colClasses);
		} else if (col.includes("d_flex")) {
			colClasses = _sortClassesDisplay(col, columns, colClasses);
		} else if (col.includes("d_inline_flex")) {
			colClasses = _sortClassesDisplay(col, columns, colClasses);
		}
	}
	return colClasses;
}

function _sortClassesDisplay(col: any, columns: any, colClasses: any) {

	// none inline inline-block block table table-cell table-row flex inline-flex
	if (col == "d_none") {
		return _displaythis("d-none", colClasses);
	} else if (col == "d_x_none") {
		return _addTogether(columns, col, "d-", "-none", colClasses);
	} else if (col == "d_inline") {
		return _addTogether(columns, col, "d-", "-inline", colClasses);
	} else if (col == "d_inline_block") {
		//return _displaythis("d-"+columns[col]+"-inline-block",colClasses)
		return _addTogether(columns, col, "d-", "-inline-block", colClasses);
	} else if (col == "d_block") {
		//return _displaythis("d-"+columns[col]+"-block",colClasses);
		return _addTogether(columns, col, "d-", "-block", colClasses);
	} else if (col == "d_table") {
		//return _displaythis("d-"+columns[col]+"-table",colClasses);
		return _addTogether(columns, col, "d-", "-table", colClasses);
	} else if (col == "d_table_cell") {
		//return _displaythis("d-"+columns[col]+"-table-cell",colClasses);
		return _addTogether(columns, col, "d-", "-table-cell", colClasses);
	} else if (col == "d_table_row") {
		//return _displaythis("d-"+columns[col]+"-table-row",colClasses);
		return _addTogether(columns, col, "d-", "-table-row", colClasses);
	} else if (col == "d_flex") {
		//return _displaythis("d-"+columns[col]+"-flex",colClasses);
		return _addTogether(columns, col, "d-", "-flex", colClasses);
	} else if (col == "d_inline_flex") {
		//return _displaythis("d-"+columns[col]+"-inline-flex",colClasses);
		return _addTogether(columns, col, "d-", "-inline-flex", colClasses);
	}

	function _addTogether(columns: any, col: any, start: any, end: any, colClasses: any = "") {
		//var col = "";
		//console.log(columns[col])
		//console.log(start+" "+end)
		if (Array.isArray(columns[col])) {
			var p = "";
			for (var i = 0; i < columns[col].length; i++) {
				if (i == 0) {
					p = start + columns[col][i] + end;
				} else {
					p += " " + start + columns[col][i] + end;
				}
			}

			var r = _displaythis(p, colClasses);
			console.log(r);
			return r;
		} else {
			return _displaythis(start + columns[col] + end, colClasses);
		}
	}

	function _displaythis(d: any, columnClassesString: any) {
		if (columnClassesString == "") {
			columnClassesString = d;
		} else {
			columnClassesString = columnClassesString + " " + d;
		}
		return columnClassesString;
	}
}
function _sortClassesVisible(col: any, columns: any, colClasses: any) {
	if (colClasses == "") {
		//colClasses = "visible-"+columns[col];
		colClasses = "d-" + columns[col] + "-none";
	} else {
		colClasses = " visible-" + columns[col];
	}
	return colClasses;
}
function _sortClassesHidden(col: any, columns: any, colClasses: any) {
	if (colClasses == "") {
		colClasses = "hidden-" + columns[col];
	} else {
		colClasses = " hidden-" + columns[col];
	}
	return colClasses;
}
function _sortClassesOffset(col: any, columns: any, colClasses: any) {
	if (col.includes("-")) {
		var c = col.split("-");
		// offset-md-
		// col-md-offset-3
		if (colClasses == "") {
			colClasses = "offset-" + c[1] + "-" + columns[col] + " ";
			//colClasses = colClasses+"col-"+c[1]+"-"+c[0]+"-"+columns[col]+" ";
		} else {
			colClasses = " offset-" + c[1] + "-" + columns[col] + " ";
			//colClasses = " "+colClasses+"col-"+c[1]+"-"+c[0]+"-"+columns[col]+" ";
		}
	} else if (col.includes("_")) {
		var c = col.split("_");
		if (colClasses == "") {
			colClasses = "offset-" + c[1] + "-" + columns[col] + " ";
			//colClasses = colClasses+"col-"+c[1]+"-"+c[0]+"-"+columns[col]+" ";
		} else {
			colClasses = " offset-" + c[1] + "-" + columns[col] + " ";
			//colClasses = colClasses+"col-"+c[1]+"-"+c[0]+"-"+columns[col]+" ";
		}
	} else {
		if (colClasses == "") {
			colClasses = "offset-" + columns[col] + " ";
			//colClasses = colClasses+"col-"+c[1]+"-"+c[0]+"-"+columns[col]+" ";
		} else {
			colClasses = " offset-" + columns[col] + " ";
			//colClasses = colClasses+"col-"+c[1]+"-"+c[0]+"-"+columns[col]+" ";
		}
	}
	return colClasses;

}






function ContainerComponent_addComponent(component: any, isEmpty: any, self: any) {
	if (document.getElementById(self.getId())) {
		addToDOM();
	} else {
		self.onAttachOnceListener(function () {
			addToDOM();
		});
	}
	function addToDOM() {
		if (!Utils.isNull(isEmpty) && isEmpty == true) {
			$("#" + self.getId()).empty();
		}
		$("#" + self.getId()).append(component.getHtml());
		component.initializeListeners();
	}
}




var Utils = {

	setCookie: function (cname: any, cvalue: any, exdays: any) {
		const d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	},
	getCookie: function (cname: any) {
		let name = cname + "=";
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c?.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c?.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	},
	checkCookie: function () {
		let username: string | null = this.getCookie("username");
		if (username != "") {
			alert("Welcome again " + username);
		} else {
			username = prompt("Please enter your name:", "");
			if (username != "" && username != null) {
				this.setCookie("username", username, 365);
			}
		}
	},

	/**
	 * Disable auto fill for chrome browser
	 */
	disbaleAutofill: function () {
		//put readonly attribute on all fields and mark those, that already readonly
		$.each($('input'), function (i: any, el: any) {
			if ($(el).attr('readonly')) {
				$(el).attr('shouldbereadonly', 'true');
			} else {
				$(el).attr('readonly', 'readonly');
			}
		});

		//Remove unnecessary readonly attributes in timeout
		setTimeout(function () {

			$.each($('input'), function (i: any, el: any) {
				if (!$(el).attr('shouldbereadonly')) {
					$(el).attr('readonly', null);
				}
			});

		}, 500);

		// https://stackoverflow.com/questions/23156578/google-chrome-autofilling-all-password-inputs
		// https://www.google.com/search?q=chrome+autofilling+password+on+signup+form&oq=chrome+autofilling+password+on+signup+form&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQIRigATIHCAIQIRigATIHCAMQIRigATIHCAQQIRigAdIBCTEwODg2ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8
		// https://github.com/terrylinooo/disableautofill.js
	},


	remove$: function (myString: any) {
		return myString.replace(/\$\{[^}]*\}/g, '');
	},

	getStringBetween: function (str: any, startChar: any = undefined, endChar: any = undefined) {
		// console.log(str);
		// const regex = new RegExp(`${startChar}(.*?)${endChar}`);
		const regex = new RegExp(`\{(.*?)\}`);
		const match = regex.exec(str);
		return match ? match[1] : null;
	},

	/**
	 * styletypes = normal | hash
	 * @param {*} text  
	 * @param {*} variable 
	 * @param {*} replacement 
	 * @param {*} styletype 
	 * @returns 
	 */
	sanitizeReplace: function (text: any, variable: any, replacement: any, styletype: any) {
		if (styletype != undefined) {
			if (styletype == "normal") {
				return text.replaceAll("${" + variable + "}", replacement);
			} else if (styletype == "hash") {
				return text.replaceAll("$#" + variable, replacement);
			}
		}
		return text.replaceAll("${" + variable + "}", replacement);
	},

	variablesReplace: function (text: any, variables: any, styletype: any = undefined) {
		let self = this;
		for (let i = 0; i < variables.length; i++) {
			let name = variables[i].name;
			let value = variables[i].value;
			text = self.sanitizeReplace(text, name, value, styletype);
		}
		return text;
	},

	getRandomInt(min: any, max: any) {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
	},

	numberId: function (len: any) {
		return Utils_randomNumberGenerator(len)
	},

	// 55555
	// https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript


	validateEmail: function (email: any) {
		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	},


	findById: function (id: any) {
		return document.getElementById(id);
	},

	queryEl: function (selector: any) {
		return document.querySelector(selector)
	},

	createElement: function (type: any, options: any) {
		return Utils_createELement(type, options);
	},

	/**
	* Convert seconds into time hh:mm:ss
	*
	*/
	secondsToHms: function (d: any) {
		d = Number(d);
		var h: string | number = Math.floor(d / 3600);
		var m: string | number = Math.floor(d % 3600 / 60);
		var s: string | number = Math.floor(d % 3600 % 60);

		h = (h < 10) ? "0" + h : h;
		m = (m < 10) ? "0" + m : m;
		s = (s < 10) ? "0" + s : s

		// var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
		// var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
		// var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
		//return hDisplay + mDisplay + sDisplay; 

		return h + ":" + m + ":" + s;
	},



	isNull: function isNull(obj: any) {
		var check = true;
		if (obj != undefined && obj != null) {
			check = false;
		}
		return check;
	},


	removeSelector: function (selector: any) {
		if (selector.charAt(0) == "#" || selector.charAt(0) == ".") {
			selector = selector.slice(1);
		}
		return selector;
	},

	randomGenerator: function (len: any, specialChars: any = null) {
		return Utils_randomGenerator(len, specialChars);
	},

	isObject: function (item: any) {
		return (item && typeof item === 'object' && !Array.isArray(item));
	},

	mergeDeep: function (target: any, ...sources: any): any {
		if (!sources.length) return target;
		const source = sources.shift();

		if (Utils.isObject(target) && Utils.isObject(source)) {
			for (const key in source) {
				if (Utils.isObject(source[key])) {
					if (!target[key]) Object.assign(target, { [key]: {} });
					Utils.mergeDeep(target[key], source[key]);
				} else {
					Object.assign(target, { [key]: source[key] });
				}
			}
		}

		return Utils.mergeDeep(target, ...sources);
		// structuredClone
	},

	deepMerge: function (old_target: any, old_source: any) {
		let target = structuredClone(old_target);
		let source = structuredClone(old_source);
		for (const key in source) {
			if (typeof source[key] === 'object' && source[key] !== null) {
				let type = {};
				if (Array.isArray(source[key])) { type = []; }
				target[key] = this.deepMerge(target[key] || type, source[key]);
			} else {
				target[key] = source[key];
			}
		}
		return target;
	},

	deepMerge2: function (old_target: any, old_source: any) {
		let target = structuredClone(old_target);
		let source = structuredClone(old_source);
		for (const key in source) {
			if (typeof source[key] === 'object' && source[key] !== null) {
				let type = {};
				if (Array.isArray(source[key])) { type = []; }
				target[key] = this.deepMerge2(target[key] || type, source[key]);
			} else {
				if (target[key] == undefined || target[key] == null) {
					target[key] = source[key];
				}
			}
		}
		return target;
	},

	/**
	* Convert string to HTML element
	*
	* @return {String}
	*/
	convertStringToHTMLNode: function (string: any, isFrag: any = false) {
		return Utils_convertStringToHTMLNode(string, isFrag);
	},

	/**
	*	Convert DOM element to string
	*
	* @return {DOMElement}
	*/
	convertFragmentToHTMLText: function (fragment: any) {
		return Utils_convertFragmentToHTMLText(fragment);
	},




	/**
	* Determins if String contains special characters
	* The first parameter is the string to match against.
	* The secound paramters [optional] is an array of
	* exceptions. Special character include those specified
	* by Support.Utils.specialChars array.
	* The third and fourth params determines if the charExecptions
	* can begin and/or end with the exception characters.
	* If multiples is false then exception characters cannot have
	* special characters side by side.
	*
	* Change to check every character to see if it is an alpha numaric character insteed
	* checking for the special characters
	*/
	containsSpecialChars: function (str: any, charExceptions: any, canBegin: any, canEnd: any, multiples: any) {
		return Utils_containsSpecialChars(str, charExceptions, canBegin, canEnd, multiples);
	},

	/**
	* An Array of special characters
	*
	*/
	specialChars: ["!", "@", "#", "$", "%", "^", "&", "*", "(", ")",
		"+", "=", "~", "`", "{", "}", "[", "]", "|", "\\",
		";", ":", "'", "\"", "<", ">", ",", "?", "/",
		"-", "_", " ", "."],

	/**
	* Test if character is valid
	* 
	* @return {Boolean} - isValid
	*/
	validKey: function (key: any) {
		return Utils_validKey(key);
	},

	/**
	* Allowed characters
	* 
	* @return {Object}
	*/
	allowOnlyCharacters: function (str: any) {
		return Utils_allowOnlyCharacters(str);
	},



	/**
	* Get time as a string example "04:46:27 PM".
	*
	* @return {String} time
	*/
	getClockTime: function () {
		return Utils_getClockTime();
	},


	/**
	* Calculates a persons age give thier birthday.
	* var bday = new Date('07/28/1984');
	* var age = calculageAge(bday);
	*
	* @param {Date} - birthday
	* @return {Number} - age
	*/
	calculateAge: function (birthday: any) { // birthday is a date object
		var ageDifMs = Date.now() - birthday.getTime();
		var ageDate = new Date(ageDifMs); // miliseconds from epoch
		return Math.abs(ageDate.getUTCFullYear() - 1970);
	},



	/**
	* Detects browser !may not work properly 
	*
	*/
	detectEngine: function () {
		return Utils_detectEngine();
	},

	/** 
	* Count how bytes are in a string
	*/
	byteCount: function (s: any) {
		return encodeURI(s).split(/%..|./).length - 1;
	},

	/**
	* Remove newline characters
	*
	* @param {String} - String to parse
	* @return {String} 
	*/
	removeNewLines: function (d: any, endAlso: any) {
		var content = d.replace(/(\r?\n|\r)+/, '');//.trim(); (\r?\n|\r)+$/
		if (Utils.isNull(endAlso) || endAlso == true) {
			content = content.replace(/(\r?\n|\r)+$/, '');
		}
		return content;
	},

	/**
	* Determins if an array has duplicates.
	*
	* @return {Boolean}
	*/
	doesArrayContainDuplicate: function (a: any) {
		var counts = [];
		for (var i = 0; i <= a.length; i++) {
			if (counts[a[i]] === undefined) {
				counts[a[i]] = 1;
			} else {
				return true;
			}
		}
		return false;
	},




	insertPeriod: function (str: any) {
		if (str.length < 2) {
			return str; // Not enough characters to insert a period
		}

		// Extract the last two characters and the rest of the string
		const lastTwo = str.slice(-2);
		const rest = str.slice(0, -2);

		// Combine the parts with a period in between
		return rest + "." + lastTwo;
	},




	// http://www.java2s.com/Code/JavaScript/Form-Control/MoneyFormat.htm


	isMobile: function () {
		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			// true for mobile device
			return true;
		} else {
			// false for not mobile device
			return false;
		}

	},

	jqueryDropdown: function () {
		Utils_jqueryDropDown();
	},


	isFileType: function (type: any, file: any) {
		if (type == "image") {
			const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp']; // Add more if needed
			// Check by MIME type
			// if (imageTypes.includes(file.type)) {return true;}
			const extension = file.split('.').pop().toLowerCase();
			return ['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(extension);
		}
		if (type == "pdf") {
			const extension = file.split('.').pop().toLowerCase();
			return ['pdf'].includes(extension);
		}

	},

	isImageMimeType: function (file: any) {
		const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp']; // Add more if needed
		if (imageTypes.includes(file.type)) { return true; } // Check by MIME type
	},

	imageExists: function (image_url: any) {
		if (image_url.includes("http") == false) { return false; }
		try {
			var http = new XMLHttpRequest();
			http.open('HEAD', image_url, false);
			http.send();
			return http.status != 404;
		} catch (e) {
			console.log(e);
			return false;
		}
	},

	updateURLParams: function (params: any, data: any, retain: any) {
		const currentURL = new URL(window.location.href);
		let searchParams = new URLSearchParams(currentURL.search);
		if (retain != undefined && retain == false) {
			searchParams = new URLSearchParams();
		}
		for (const [key, value] of Object.entries(params)) {
			searchParams.set(key, value as string);
		}

		const newURL = `${currentURL.pathname}?${searchParams.toString()}`;
		window.history.pushState(data, '', newURL);
	},

	sha256: async function (message: any) {
		const encoder = new TextEncoder();
		const data = encoder.encode(message);
		const hashBuffer = await crypto.subtle.digest('SHA-256', data);
		const hashArray = Array.from(new Uint8Array(hashBuffer));
		const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
		return hashHex;

		// sha256("Hello World").then(hash => console.log(hash));
	},


	appendStyles: function (styles: any) {
		for (let i = 0; i < styles.length; i++) {
			const style = document.createElement('link');
			style.type = 'text/css';
			style.rel = "stylesheet";
			style.href = styles[i][0];
			style.id = styles[i][1];
			if (document.getElementById(style.id) == undefined) {
				document.head.appendChild(style);
			}
		}
	},
	appendScripts: function (scripts: any) {
		for (let i = 0; i < scripts.length; i++) {
			const script = document.createElement('script');
			script.src = scripts[i][0];
			script.id = scripts[i][1];
			// setTimeout(() => {
			// script.async = true; // Optional: Load the script asynchronously
			if (document.getElementById(script.id) == undefined) {
				document.head.appendChild(script);
			}
			// },100);
		}
	},


	FullPageLoader: function (active: any, message: any) {
		if (message == undefined) message = "Preparing dashboard";
		function application_loader_screen_html(message: any) {
			return `
            <div id="afs-main-loader-screen">
            <div class="page page-center">
            <div class="container container-slim py-4">
                <div class="text-center">
                <div class="mb-3">
                    <a href="." class="navbar-brand navbar-brand-autodark"><img src="" height="36" alt=""></a>
                </div>
                <div class="text-secondary mb-3">${message}</div>
                <div class="progress progress-sm">
                    <div class="progress-bar progress-bar-indeterminate"></div>
                </div>
                </div>
            </div>
            </div>
            </div>
            `;
		}
		// $("#afs-main-loader-screen").empty();
		if (active) {
			document.body.insertAdjacentHTML("afterbegin", application_loader_screen_html(message));
		} else {
			$("#afs-main-loader-screen").remove();
		}
	}

};




/////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////
/* 0000 - Utils */
// 4444
function Utils_createELement(type: any, options: any) {
	// 151515
	if (Utils.isNull(type)) {
		return document.createElement('div');
	}
	var inputTypes = ["input", "checkbox", "radio", "submit", "file"];
	var ownTypes = ["el", "selector", "_el", "_selector", "body"];
	var oneParam = ["disabled", "selected"];
	if (typeof type !== 'string') {
		options = type;
		if (!Utils.isNull(options) && !Utils.isNull(options.el)) {
			type = options.el;
		} else {
			if (!Utils.isNull(options.type) && isInputType(options.type)) {
				type = options.type;
			} else {
				type = "div";
			}
		}
	}

	var element = document.createElement(type);
	for (var i = 0; i < inputTypes.length; i++) {
		if (inputTypes[i] == type) {
			element = document.createElement('input');
			element.type = type;
			break;
		}
	}
	function isInputType(t: any) {
		var isType = false;
		for (var i = 0; i < inputTypes.length; i++) {
			if (inputTypes[i] == t) {
				isType = true;
				break;
			}
		}
		return isType;
	}
	if (Utils.isNull(element)) {
		return document.createElement('div');
	}
	for (let i in options) {
		var isOwnType = false;
		for (var n = 0; n < ownTypes.length; n++) {
			if (ownTypes[n] == i) {
				isOwnType = true;
				break;
			}
		}
		if (isOwnType) continue;
		if (!Utils.isNull(element)) {
			if (i == "className") {
				element.className = options[i];
			} else if (i == "innerHTML") {
				element.innerHTML = options[i];
			} else {
				//console.log(i);
				//console.log(options[i]);
				if (i.charAt(0) != "_")
					element.setAttribute(i, options[i]);
			}

		}
	}
	return element;
}
function Utils_randomGenerator(len: any, specialChars: any) {
	var text = "";
	var possible = null;
	if (specialChars == null || specialChars == undefined || specialChars == false)
		possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	else
		possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789=+!#*^_";

	if (len == null || len == undefined) len = 5;

	for (var i = 0; i < len; i++)
		text += possible.charAt(Math.floor(Math.random() * possible.length));

	return text;
}
function Utils_randomNumberGenerator(len: any) {
	let text = "";
	let possible = "0123456789";
	if (len == null || len == undefined) len = 5;

	for (var i = 0; i < len; i++)
		text += possible.charAt(Math.floor(Math.random() * possible.length));
	return text;
}
function Utils_convertStringToHTMLNode(string: any, isFlag: any = null) {
	if (typeof string === "object") return string;
	var xmlString = string,
		parser = new DOMParser(),
		doc = parser.parseFromString(xmlString, "text/html");
	var frag = document.createDocumentFragment();
	if (!Utils.isNull(doc.body)) {
		for (var i = 0; i < doc.body.childNodes.length; i++) {
			frag.appendChild(doc.body.childNodes[i]!.cloneNode(true));
		}
	}
	return frag.cloneNode(true);
}
function Utils_convertFragmentToHTMLText(fragment: any) {
	var div = document.createElement('div');
	div.appendChild(fragment.cloneNode(true));
	var html = div.innerHTML;
	return html;
}
function Utils_containsSpecialChars(str: any, charExceptions: any, canBegin: any, canEnd: any, multiples: any) {
	var contains = false;

	if (charExceptions == null || charExceptions == undefined) {
		for (var i = 0; i < Utils.specialChars.length; i++) {
			var includes = str.includes(Utils.specialChars[i]);
			if (includes) {
				return true;
			}
		}
	} else {
		var s = str.split("");
		for (var i = 0; i < Utils.specialChars.length; i++) {
			var special_character = Utils.specialChars[i];
			var includes = str.includes(special_character);
			if (includes) {
				if (canBegin != undefined && !canBegin) {
					if (str.startsWith(special_character)) {
						return true;
					}
				}
				if (canEnd != undefined && !canEnd) {
					if (str.endsWith(special_character)) {
						return true;
					}
				}
				for (var v = 0; v < s.length; v++) {
					if (s[v] == special_character) {
						if (!isExceptionCharacter(s[v], charExceptions)) {
							contains = true;
							break;
						}
					}
				}
			}
			if (multiples != undefined && multiples) {

			}
		}
	}

	function isExceptionCharacter(ch: any, exceptions: any) {
		var _isException = false;
		for (var h = 0; h < exceptions.length; h++) {
			if (ch == exceptions[h]) {
				_isException = true;
				break;
			}
		}
		return _isException;
	}


	//console.log(charExceptions);
	//console.log(str);
	//console.log(contains);

	return contains;

}
function Utils_validKey(key: any) {
	var validKey = false;
	var k1 = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
		'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
		'0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '_', '.', '-'];

	var k = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
		'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
		'0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

	var k2 = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
		'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

	for (var i = 0; i < k.length; i++) {
		if (k[i] == key) {
			validKey = true;
		}
	}
	return validKey;
}
function Utils_allowOnlyCharacters(str: any) {
	// var allowed = "abcdefghijklmnopqrstuvwxyz-ABCDEFGHIJKLMNOPQRSTUVWXYZ-1234567890-_.()";
	var allowed: any = "abcdefghijklmnopqrstuvwxyz-ABCDEFGHIJKLMNOPQRSTUVWXYZ_1234567890";
	allowed = allowed.split("");
	str = str.split("");
	var character = "";
	for (var n = 0; n < str.length; n++) {
		var check = false;
		for (var i = 0; i < allowed.length; i++) {
			if (allowed[i] == str[n]) {
				check = true;
				break;
			}
		}

		if (!check) {
			return {
				character: character,
				isValid: false
			};
			break;
		}
	}

	return {
		character: character,
		isValid: true
	};
}
function Utils_getClockTime() {
	// var now    = new Date();
	// var hour   = now.getHours();
	// var minute = now.getMinutes();
	// var second = now.getSeconds();
	// var ap = "AM";
	// if (hour   > 11) { ap = "PM";             }
	// if (hour   > 12) { hour = hour - 12;      }
	// if (hour   == 0) { hour = 12;             }
	// if (hour   < 10) { hour   = "0" + hour;   }
	// if (minute < 10) { minute = "0" + minute; }
	// if (second < 10) { second = "0" + second; }
	// var timeString = hour + ':' + minute + ':' + second + " " + ap;
	// return timeString;
}
function Utils_detectEngine() {
	// // Edge 20+
	// var isEdge = !Support.Utils.isIE && !!window.StyleMedia;

	// // Opera 8.0+
	// var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

	// // Firefox 1.0+
	// var isFirefox = typeof InstallTrigger !== 'undefined';

	// // Safari 3.0+ "[object HTMLElementConstructor]"
	// var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

	// // Internet Explorer 6-11
	// var isIE =  /*@cc_on!@*/false || !!document.documentMode;

	// // Chrome 1+
	// var isChrome = !!window.chrome && !!window.chrome.webstore;

	// // Blink engine detection
	// var isBlink = (isChrome || isOpera) && !!window.CSS;
	// return {
	// 	isEdge: isEdge,
	// 	isOpera: isOpera,
	// 	isFirefox: isFirefox,
	// 	isSafari: isSafari,
	// 	isIE: isIE,
	// 	isChrome: isChrome,
	// 	isBlink: isBlink
	// };
}
function Utils_jqueryDropDown() {
	(function ($) { // Begin jQuery
		$(function () { // DOM ready
			// If a link has a dropdown, add sub menu toggle.
			$('nav ul li a:not(:only-child)').click(function (this: any) {
				$(this).siblings('.nav-dropdown').toggle();
				// Close one dropdown when selecting another
				$('.nav-dropdown').not($(this).siblings()).hide();
				this.e.stopPropagation();
			});
			// Clicking away from dropdown will remove the dropdown class
			$('html').on('click', function () {
				$('.nav-dropdown').hide();
			});
			// Toggle open and close nav styles on click
			$('.nav-toggle').click(function () {
				$('nav ul').slideToggle();
			});
			//setTimeout(function(){
			// Hamburger to X toggle
			$('.nav-toggle').on('click', function (this: any) {
				this.classList.toggle('active');
			});
			$('nav ul li a:not(:only-child)').hover(function (this: any) {
				runthis(this.e, this);
			}, function (e: any) {
				//runthis(e,this);
			});
			function runthis(event: any, element: any) {
				if (window.matchMedia("(max-width: 767px)").matches) {
					// The viewport is less than 768 pixels wide
					//console.log("This is a mobile device.");
				} else {
					//console.log("This is NOT a mobile device.");
					$(element).siblings('.nav-dropdown').toggle();
					// Close one dropdown when selecting another
					$('.nav-dropdown').not($(element).siblings()).hide();
					event.stopPropagation();
				}
			}

			//$("*").click(function(e){}); mnl_about:hover

			// $('.nav-dropdown').hover(function(e){
			// 	console.log($('.mnl_about::after'))
			// 	//$('.mnl_about:after').css({"margin-left": "49%","width": "80%"});
			// },function(e){
			// 	//$('.mnl_about:after').css({"margin-left": "0","width": "0"});
			// });

			// $('.mnl_about:hover:after').hover(function(e){
			// 	// margin-left: 49%;
			// 	// width:80%
			// 	$()

			// },function(e){

			// });


		}); // end DOM ready

		function onCompleteTransaction(data: any) {

		}
		(window as any).onCompleteTransaction = onCompleteTransaction;

		function onErrorTransaction(data: any) {

		}
		(window as any).onErrorTransaction = onErrorTransaction;

	})(jQuery);
}



var _registered_listeneres_ = [];
var _Utils = {
	registerListenerCallbackForSelf: function (type: any, selector: any, func: any, self: any, preventDefault: any, stopPropagation: any, obj: any) {
		_Utils_registerListenerCallbackForSelf(type, selector, func, self, preventDefault, stopPropagation, obj);
	},

	registerListenerCallback: function (obj: any, self: any) {
		_Utils_registerListenerCallback(obj, self);
	}
};
function _Utils_registerListenerCallbackForSelf(type: any, selector: any, func: any, self: any, preventDefault: any, stopPropagation: any, obj: any) {
	preventDefault = (Utils.isNull(preventDefault)) ? false : preventDefault;
	stopPropagation = (Utils.isNull(stopPropagation)) ? false : stopPropagation;
	var alreadyRegistered = isEventRegistered(selector, self);
	self._props_._events.push({
		selector: selector,
		type: type,
		func: func,
		preventDefault: preventDefault,
		stopPropagation: stopPropagation,
		obj: obj
	});// 55555
	// FormEventsHandler_constructor
}

// 71717 xxxxx
var _registered_listeneres_ = [];

function RESTER_LISTENER() {

}
function _Utils_registerListenerCallback(obj: any, self: any) {
	if (obj.listener != undefined && typeof obj.listener === "function") {
		self._props_._events.push({
			selector: "",
			type: "run",
			func: obj.listener
		});
	} else if (typeof obj.listener === "object") {
		if (Array.isArray(obj.callback)) {
			for (var i = 0; i < obj.callback.length; i++) {

				var alreadyRegistered = isEventRegistered(obj.callback[i].selector, self);

				var eventType = (Utils.isNull(obj.callback[i].type)) ? "click" : obj.callback[i].type;
				//function _Utils_registerListenerCallbackForSelf(type,selector,moreData,func,self,preventDefault,stopPropagation){
				var preventDefault = (Utils.isNull(obj.callback[i].preventDefault)) ? false : obj.callback[i].preventDefault;
				var stopPropagation = (Utils.isNull(obj.callback[i].stopPropagation)) ? false : obj.callback[i].stopPropagation;
				self._props_._events.push({
					selector: obj.callback[i].selector,// "#"+(Utils.isNull(obj.callback[i].selector)) ? selector : obj.callback[i].selector,
					type: eventType,
					func: obj.callback[i].func,
					preventDefault: preventDefault,
					stopPropagation: stopPropagation
				});
			}
		} else {
			var eventType = (Utils.isNull(obj.callback.type)) ? "click" : obj.callback.type;
			var preventDefault = (Utils.isNull(obj.callback.preventDefault)) ? false : obj.callback.preventDefault;
			var stopPropagation = (Utils.isNull(obj.callback.stopPropagation)) ? false : obj.callback.stopPropagation;

			var alreadyRegistered = isEventRegistered(obj.callback.selector, self);
			//if(alreadyRegistered) return;

			self._props_._events.push({
				selector: obj.callback.selector,//"#"+(Utils.isNull(obj.callback.selector)) ? selector : obj.callback.selector,
				type: eventType,
				func: obj.callback.func,
				preventDefault: preventDefault,
				stopPropagation: stopPropagation
			});
		}
	}
}
function isEventRegistered(selector: any, self: any) {
	var alreadyRegistered = false;
	//console.log(self);
	for (var i = 0; i < self._props_._events.length; i++) {
		var sel = self._props_._events[i].selector;
		if (sel == selector) {
			alreadyRegistered = true;
			break;
		}
	}
	return alreadyRegistered;
}










// 101010 // 949494


class App {
	static init: any;
	static selector: any;
	static _element: any;
	constructor() {

	}

	static call(context: any) {
		return new App.init(context);
	}

	post(url: any, data: any, callback: any) {
		if (typeof data === "function") {
			callback = data;
			data = null;
		}
		request(url, data, callback, "POST");
	}

	get = function (url: any, data: any, callback: any) {
		if (typeof data === "function") {
			callback = data;
			data = null;
		}
		request(url, data, callback, "GET");
	}


}



// Static methods
App.init = function (selector: any, all: any) {
	this.selector = selector;
	this._element = null;

	if (!selector) {
		return this;
	}

	if (isNode(selector) || isElement(selector)) {
		this._element = selector;
	} else if (selector == "body") {
		this._element = document.body;
	} else {
		this._element = document.querySelectorAll(selector);
	}
	return this;
};


function request(url: any, data: any, callback: any, type: any) {
	var xhttp = new XMLHttpRequest();

	xhttp.onreadystatechange = function () {
		if (this.readyState == 4 && this.status == 200) {
			if (callback != undefined && callback != null && typeof callback === "function") {
				callback(this.responseText, this.status, this);
			}
		}
		//if (this.readyState == 4 && this.status == 200) {}
	};
	var urlParams = "";
	if (data != undefined && data != null) {
		urlParams = new URLSearchParams(data).toString();
	}

	if (type == "POST") {
		xhttp.open(type, url, true);
		//xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=UTF-8");
		xhttp.send(urlParams);
	} else {
		if (urlParams == "") urlParams = "?" + urlParams;
		//xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=UTF-8");
		xhttp.open(type, url + urlParams, true);
		xhttp.send();
	}
}
// Instance methods
App.init.prototype.print = function (contents: any) {
	var self = this;
	_activateNodeList(this._element, function (node: any) {

	}, self);
	console.log(contents);
};
App.init.prototype.append = function (element: any) {
	var self = this;
	_activateNodeList(this._element, function (node: any) {
		if (typeof element === 'string' && element.trim() != "body") {
			element = Utils.convertStringToHTMLNode(element);
		}
		node.appendChild(element);
	}, self);
	return this;
};
App.init.prototype.attr = function (param: any, value: any) {
	var self = this;
	_activateNodeList(this._element, function (node: any) {
		node.setAttribute(param, value);
	}, self);
	//this._element.setAttribute(param, value);
	return this;
};// 55555
App.init.prototype.click = function (callback: any) {
	var self = this;
	self.on('click', callback);
	return this;
};
App.init.prototype.on = function (event: any, callback: any) {
	var self = this;
	self._method = function (e: any) {
		self.preventDefault = function () {
			e.preventDefault();
		}
		self.target = e;
		callback(self);
	}
	self._type = event;

	_activateNodeList(self._element, function (node: any) {
		node.addEventListener(self._type, self._method);
	}, self);
	//this._element.addEventListener(this._type, this._method);
	return this;
};
App.init.prototype.removeListener = function () {
	var self = this;
	_activateNodeList(this._element, function (node: any) {
		if (self._method != undefined && self._type != undefined)
			node.removeEventListener(self._type, self._method);
	}, self);
	return this;
};
App.init.prototype.css = function (propName: any, val: any) {
	// var self = this;

	// _activateNodeList(this._element,function(node:any){
	// 	if(val==undefined && typeof propName === 'object'){
	// 		var style = "";//this._element.getAttribute('style');
	// 		for(let prop in propName){
	// 			style = style + prop +":"+ propName[prop] + ";";
	// 		}
	// 		node.setAttribute("style",style);
	// 	}else{
	// 		node.setAttribute(propNamm,val);
	// 	}
	// },self);

	// return this;
};
// 4444 - create polyfills for these methods 
App.init.prototype.addClass = function (val: any) {
	var self = this;
	_activateNodeList(this._element, function (node: any) {
		node.classList.add(val);
	}, self);

	return this;
};
App.init.prototype.removeClass = function (val: any) {
	var self = this;
	_activateNodeList(this._element, function (node: any) {
		node.classList.remove(val);
	}, self);

	return this;
};

// 4444 - check how jquery handles this
App.init.prototype.hasClass = function (val: any) {
	var self = this;

	// for (let i = 0; i < myNodelist.length; i++) {}

	// if(this._element.length > 0){
	// 	return this._element[0].classList.contains(val);
	// }else{
	// 	return false;
	// }

	//return this._element.classList.contains(val);
};
App.init.prototype.html = function (html: any) {
	var self = this;
	if (html == undefined) {
		return this._element;
	} else {
		_activateNodeList(this._element, function (node: any) {
			node.innerHTML = html;
		}, self);
	}
	return this;
};
App.init.prototype.htmlAsStringCopy = function (selector: any) {
	var self = this;
	var str = "";
	_activateNodeList(this._element, function (node: any) {
		str = str + "" + Utils.convertFragmentToHTMLText(node.cloneNode(true));
	}, self);

	return str;
};
App.init.prototype.empty = function () {
	// var self = this;
	// _activateNodeList(this._element,function(node:any){
	// 	while (node.firstChild) {
	// 		node.removeChild(this._element.lastChild);
	// 	} 
	// },self);
	// //this._element.innerHTML = "";

	// return this;
};
// Method chaining example
App.init.prototype.flash = function () {
	var self = this;
	_activateNodeList(this._element, function (node: any) {

	}, self);
	document.body.style.backgroundColor = '#ffc';
	setInterval(function () {
		document.body.style.backgroundColor = '';
	}, 5000);
	return this;
};

function _activateNodeList(myNodelist: any, cb: any, self: any) {

	if (isNode(myNodelist) || isElement(myNodelist)) {
		return cb(myNodelist);
	}
	for (let i = 0; i < myNodelist.length; i++) {
		//myNodelist[i].style.color = "red";
		cb(myNodelist[i]);
	}
}
//Returns true if it is a DOM node
function isNode(o: any, self: any = null) {
	return (
		typeof Node === "object" ? o instanceof Node :
			o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string"
	);
}

//Returns true if it is a DOM element    
function isElement(o: any, self: any = null) {
	return (
		typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
			o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string"
	);
}
function _addAppElementToList(self: any) {

}








let CONNECTED_COMPONENTS: any = [];
// 7676 50505 77777 xxxxx // ddddd
function ApplicationManager_start_runInterval(self: any) {
	let interval = setInterval(function () {
		//var GL_COMPONENTS = self.getComponents();
		var components = self.getComponents();
		// console.log(components);
		for (let i = 0; i < components.length; i++) {
			const index = i;
			if (document.getElementById(components[index].id)) {
				AppComponent_Attach(components, index, self);
			} else if (document.querySelector("[data-afscomp=" + components[index].id + "]")) {
				AppComponent_Attach(components, index, self);
			} else {
				components[i].component.deInitializeListener();
				if (CONNECTED_COMPONENTS.includes(components[i].id) === true) {
					var _index = CONNECTED_COMPONENTS.indexOf(components[i].id);
					if (_index > -1) {
						CONNECTED_COMPONENTS.splice(_index, 1);
						var comp = components[i].component._props_._dom_events;
						ApplicationManager_start_handleDeAttachEvents(comp);
						components[i].component._props_._event_flag = false;
					}
				}
			}
		}
	}, 100);
}

function AppComponent_Attach(components: any, index: any, self: any) {
	if (CONNECTED_COMPONENTS.includes(components[index].id) === false) {
		components[index].component.initializeListeners();
		CONNECTED_COMPONENTS.push(components[index].id);
		var comp = components[index].component._props_._dom_events;
		// activate attach events xxxxx
		ApplicationManager_start_handleAttachEvents(comp, components[index].component);
	}
}
function ApplicationManager_start_handleAttachEvents(comp: any, component: any) {
	if (!Utils.isNull(comp)) {
		if (comp._addToDOMEventOnce && comp._addToDOMCount < 1) {
			comp._addToDOMCount++;
			comp._addToDOMEventOnce();
		}
		if (comp._addToDOMEvent) {
			if (Array.isArray(comp._addToDOMEvent)) {
				for (var k = 0; k < comp._addToDOMEvent.length; k++) {
					//console.log(component)
					comp._addToDOMEvent[k]();
				}
			} else {
				comp._addToDOMEvent();
			}
		}
	}
}
function AppComponent_initializeListeners(self: any) {

	// self._props_._events.push({
	// 	selector: selector,
	// 	type: type,
	// 	func: func,
	// 	preventDefault: preventDefault,
	// 	stopPropagation: stopPropagation
	// }); 979797


	for (var i = 0; i < self._props_._events.length; i++) {
		var eventObj = self._props_._events[i];
		_initialize_event(eventObj);
	}

	self._props_._event_flag = true;
	function _initialize_event(eventObj: any) {

		if (eventObj.type == "run") {
			eventObj.func({
				data: eventObj,
				self: self,
				args: self._props_._args
			});

		} else {
			//$("#"+eventObj.id).off();
			//console.log(document.getElementById(eventObj.selector.substring(1)));
			const myInput = document.getElementById(eventObj.selector.substring(1)) as HTMLInputElement;
			// if(document.getElementById(document.getElementById(eventObj.selector.substring(1) ))){
			if (myInput) {
				_runsetupinitializelistener(eventObj, self);
			} else {
				checkagain(eventObj, self);
			}
		}//
	}
}


function checkagain(eventObj: any, self: any) {
	setTimeout(function () {

		if (self._props_._count_event_check_runs == undefined) {
			self._props_._count_event_check_runs = 0;
		}
		if (self._props_._count_event_check_runs >= 10) {
			self._props_._count_event_check_runs = 0;
			return;
		}

		if (document.getElementById(eventObj.selector.substring(1))) {
			self._props_._count_event_check_runs = 0;
			_runsetupinitializelistener(eventObj, self);
			return;
		} else {
			self._props_._count_event_check_runs++;
			checkagain(eventObj, self);
		}
	}, 500);
}
function _runsetupinitializelistener(eventObj: any, self: any) {
	$(eventObj.selector).on(eventObj.type, function (e: any) {
		if (!Utils.isNull(eventObj.preventDefault) && eventObj.preventDefault == true) {
			e.preventDefault();
		}
		if (!Utils.isNull(eventObj.stopPropagation) && eventObj.stopPropagation == true) {
			e.stopPropagation();
		}
		var d = {
			event: null,
			data: eventObj,
			self: self,
			args: self._props_._args
		};
		d["event"] = e;
		// 55555
		for (let prop in eventObj) {
			if (typeof eventObj[prop] === 'function') {
				if (document.getElementById(eventObj.selector.substring(1))) {
					const myInput = document.getElementById(eventObj.selector.substring(1)) as HTMLInputElement;
					var value = myInput.value;
					if (eventObj.obj != undefined && eventObj.obj.repsonseEventHandler) {
						eventObj.obj.repsonseEventHandler._props_._value = value;
						eventObj.obj.repsonseEventHandler._props_._event = e;
						eventObj[prop](eventObj.obj.repsonseEventHandler);
					} else {
						eventObj[prop](d);
					}
				}
				break;
			}
		}
	});
}
function AppComponent_deInitializeListener(self: any) {
	self._props_._isEventsActive = false;
}




function ApplicationManager_start_handleDeAttachEvents(comp: any) {
	if (!Utils.isNull(comp)) {
		if (comp._removeFromDOMEventOnce && comp._removeFromDOMCount < 1) {
			comp._removeFromDOMCount++;
			comp._removeFromDOMEventOnce();
		}
		if (Array.isArray(comp._removeFromDOMEvent)) {
			for (var k = 0; k < comp._removeFromDOMEvent.length; k++) {
				comp._removeFromDOMEvent[k]();
			}
		} else {
			comp._removeFromDOMEvent();
		}
	}

}
function ApplicationManager_templateParser(htmlString: any, replacements: any, opts: any, self: any) {
	// p1p1p1p1
	// ["{{more or less}}", "more or less"]
	var res = htmlString;
	//var regex = /\$(.*?)\$/g;

	if (replacements.length != 2) return htmlString;

	if (opts == null || opts == undefined) opts = {};

	var regex = /{{(.*?)}}/g;

	if (opts.delimiterRegex) {
		regex = opts.delimiterRegex;
	}

	var matched = regex.exec(htmlString);
	while (matched != null) {
		if (matched[1] == replacements[0]) {
			res = res.replace(matched[0], replacements[1]);
		}
		matched = regex.exec(htmlString);
	}
	return res;
}



// 5051 jjjj
// Array - body: ["@component",{}]
// Array - body: [function, params]
// Array - body: ["&template",{}]
// Array - body: [components...]
// Object - body: component
// Object - body: HTMLElement
// String - body: HTMLE String

// {
// 	body: "",
// 	className: "",
// 	style: "",
//  _create_element_from_this_object: true
// }

function buildBody(object: any, is_obj: any = null, self: any = null) {
	// xxxxx nnnnn 50505
	if (object == null || object == undefined) {
		return new ContainerComponent({});
	}
	if (is_obj == undefined) is_obj = false;

	let body = object.body;
	if (typeof body === "string") {
		if (body.charAt(0) == "@" || body.charAt(0) == "#") { // @membershipView:signup:view
			// TODO: 
			return _build_from_string(body, self, null, object);
		} else {
			var newbody = Utils.convertStringToHTMLNode(body);
			return newbody.cloneNode(true);
		}
	} else if (typeof body === "object") {
		return _build_from_object(body);
	} else if (typeof body === "function") {
		let b = body(object.params, gl_applicationContextManager);
		if (typeof body === "object") {
			return _build_from_object(body);
		}else{
			var newbody = Utils.convertStringToHTMLNode(b);
			return newbody.cloneNode(true);
		}
	} else if (Array.isArray(body)) {
		if (typeof body[0] === "string" && body[0].charAt(0) == "@") {
			return _build_from_string(body[0], self, body[1], object);
		} else if (typeof body[0] === "function") {

			return body[0](gl_applicationContextManager, body[1]);
		} else {
			// 4444
			// experimental: check to see if this works
			// this takes in an array of components, HTMLElements and string elements
			// and builds 1 element that returns a fragment
			var fragment = document.createDocumentFragment();
			for (var i = 0; i < body.length; i++) {
				_decomposeArray(body[i], fragment);
			}
			return fragment;
		}
	}


	function isObjEmpty(value: any) {
		for (let prop in value) {
			if (value.hasOwnProperty(prop)) return false;
		}
		return true;
	}
	function _build_from_object(body: any) {
		if (body.TYPE != undefined) {
			if (Utils.isNull(object.original) && object.original == true) {
				return body;
			} else {
				return body.getHtml();
			}
		} else {
			if (isObjEmpty(body)) {
				return "<div></div>";
			} else {
				return body;
			}

		}
	}
	function _build_from_string(body: any, self: any, params: any, object: any = null) {
		if (body.charAt(0) === "@") {
			var view = _build_view(body, params, self, object);
			if (Utils.isNull(view)) {
				//console.error("Manager.register() function did not return a component: "+body);
				return null;//new ContainerComponent(); 
			}
			if (view.TYPE) {
				return view.getHtml();
			} else {
				if (typeof view === "string") {
					return Utils.convertStringToHTMLNode(view);
				} else {
					return view;
				}
			}
		} else if (body.charAt(0) === "&") {
			var p = body.substr(1);
			// 4444
			// convet template parser
			var t = applicationManager.getLoadedFileContents(p);
			t = applicationManager.templateParser(t, null);
			var view = Utils.convertStringToHTMLNode(t);
			return view;
		} else {
			var view = Utils.convertStringToHTMLNode(body);
			return view;
		}
	}
	function _decomposeArray(b: any, fragment: any) {
		if (typeof b === "object") {
			if (b.TYPE) {
				fragment.appendChild(b.getHtml());
			} else {
				fragment.appendChild(b);
			}
		} else if (b === "string") {
			if (b.charAt(0) != "@") {
				var element = Utils.convertStringToHTMLNode(b);
				fragment.appendChild(element);
			}
		} else if (Array.isArray(b)) {
			if (typeof b[0] === "string" && b[0].charAt(0) == "@") {
				var n = _build_from_string(b[0], self, b[1]);
				if (n) {
					if (n.TYPE) {
						fragment.appendChild(n.getHtml());
					} else {
						fragment.appendChild(n);
					}
				}
			}
		}
	}
}
function _build_view(body: any, params: any, self: any, obj: any) {

	// 757575  77777 
	// var paramValues = {
	// 	parent: self,
	// 	params: params,
	// 	object: obj
	// }; hhhhh
	var paramValues = {
		"view": obj,
		// "route": route,
		// "routes": _allRoutes,
		"params": params,
		"app": gl_applicationContextManager
	};
	var method = body.slice(1);

	// 44441
	gl_applicationContextManager._props_._passedThruParams = params;
	var v = applicationManager.getMethod(method)(gl_applicationContextManager);

	var anyid = applicationManager._props_._any_id[method];


	if (anyid != undefined) {
		applicationManager.setAny(anyid, v);
	}

	if (body == '@membershipView:signup:view') {
		//console.log(v);
	}

	// hhhhh - p2p2p2p2
	return v;
}
let gl_applicationContextManager: ApplicationContextManager; 

